import React from "react";
import { MenuItem } from "@mui/material";
import { MenuActions } from "pages/autorization-payments/components/MenuActions";
import { ButtonAction, ITableElement } from "shared/components";
import { accesRoles } from "shared/models";
import { IDeduction } from "../models/IDeduction";

export const columnsDeductions = (
  onEdit?: (row: IDeduction) => void,
  onDelete?: (row: IDeduction) => void,
): ITableElement<IDeduction>[] => {
  return [
    {
      field: "conceptCode",
      headerName: "Código concepto",
      minWidth: 180,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).conceptCode ?? "",
        );
      },
    },
    {
      field: "description",
      headerName: "Descripción",
      minWidth: 260,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          params.description ?? "",
        );
      },
    },
    {
      field: "accountingAccount",
      headerName: "Cuenta contable",
      minWidth: 180,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).accountingAccount ?? "",
        );
      },
    },
    {
      field: "percentage",
      headerName: "Porcentaje",
      minWidth: 130,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).percentage ?? "",
        );
      },
    },
    {
      field: "operatingIndicator",
      headerName: "Indicador de operación",
      minWidth: 190,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).operatingIndicator ?? "",
        );
      },
    },
    {
      field: "fiscalYear",
      headerName: "Año fiscal",
      minWidth: 130,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).fiscalYear ?? "",
        );
      },
    },
    {
      field: "startDate",
      headerName: "Fecha inicio",
      minWidth: 150,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).startDate ?? "",
        );
      },
    },
    {
      field: "endDate",
      headerName: "Fecha fin",
      minWidth: 150,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).endDate ?? "",
        );
      },
    },
    {
      field: "beneficiary",
      headerName: "NIT beneficiario",
      minWidth: 180,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).beneficiary ?? "",
        );
      },
    },
    {
      field: "beneficiaryName",
      headerName: "Razón social beneficiario",
      minWidth: 280,
      renderCell(params: IDeduction) {
        return React.createElement(
          React.Fragment,
          null,
          (params as any).beneficiaryName ?? "",
        );
      },
    },
    {
      field: "actions",
      headerName: "",
      minWidth: 120,
      renderCell(params: IDeduction) {
        return React.createElement(
          MenuActions,
          null,
          React.createElement(
            MenuItem,
            null,
            React.createElement(
              ButtonAction,
              {
                roles: accesRoles.auditor,
                disabled: false,
                action: () => {
                  onEdit?.(params);
                },
              },
              React.createElement("span", null, "Editar"),
            ),
          ),
          React.createElement(
            MenuItem,
            null,
            React.createElement(
              ButtonAction,
              {
                roles: accesRoles.auditor,
                disabled: false,
                action: () => {
                  onDelete?.(params);
                },
              },
              React.createElement("span", null, "Eliminar"),
            ),
          ),
        );
      },
    },
  ];
};
